const HLocalStorageStore = {
    remove(key) {
        localStorage.removeItem(key);
    },
    put(key, value, expiryDays) {
        if (value === undefined) {
            this.remove(key)
        } else {
            const data = {
                expiry: expiryDays ? (new Date()).getTime() + (expiryDays * 24 * 60 * 60 * 1000) : undefined,
                value
            }
            localStorage.setItem(key, encodeURIComponent(JSON.stringify(data)));
        }
    },
    get(key) {
        if (localStorage.getItem(key)) {
            const data = JSON.parse(decodeURIComponent(localStorage.getItem(key)));
            if (data.expiry) {
                if ((new Date()).getTime() < data.expiry) {
                    return data.value;
                }
                else {
                    this.remove(key);
                }
            }
            else {
                return data.value;
            }
        }
    },
    cleanExpiredLocalStorageItems(prefix) {
        try {
            for (let key in localStorage) {
                if (key.startsWith(prefix)) {
                    HLocalStorageStore.get(key); // will handle deleting the expired
                }
            }
        }
        catch (e) {
        }
    }
};

if (typeof window !== "undefined") {
    window.HLocalStorageStore = HLocalStorageStore;
}